module.exports = __webpack_public_path__ + "img/logo.4ae5bba1.png";